// extracted by css-extract-rspack-plugin
export default {"root":"bRHKV7","items":"bJbnqu","item":"O6HO3D","is-selected":"ONSiHO","isSelected":"ONSiHO","user":"IqUVGU"};